import { useFormikContext } from "formik";
import React, { FC, useState } from "react";
import { DEF_PG_SIZE_WIZARD } from "../../../../constants/maximum-page-size";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import { useLocale } from "../../../../contexts/localeContext";
import { TableContextProvider } from "../../../../contexts/table/TableContextProvider";
import ModesColumns from "../../../../models/ColumnDefinitions/ModeColumns";
import ModeSearch from "../../../../models/search/ModeSearch";
import { getEventBasedFilteredByData } from "../../../../services/notificationService";
import TableTab from "../../../tabs/table-tab";

interface Props {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    setSideBarStepDescription: (discription: string) => void;
}

const FilterStep: FC<Props> = ({onBack, onNext, setSideBarStepDescription}) => {
    const [taskSelected, setTaskSelected] = useState(false);
    const [filterValue, setFilterValue] = useState({nameOriginal: '', id: 0});
    const { translate } = useLocale(); 
    const { setFieldValue } = useFormikContext<any>();

    const onLocalNext = (event: any) => {
        if (taskSelected) {
            onNext({ ...event});
            setSideBarStepDescription(filterValue.nameOriginal)
            setFieldValue("filterById", filterValue.id);
            setFieldValue("filterBy", filterValue.nameOriginal);
        }
    }

    const itemSelected = (selectedItem: any) => {
        if (selectedItem) {
            setFilterValue({
                id: selectedItem.value,
                nameOriginal: selectedItem.filterValue, 
            });
            setTaskSelected(true);
            onNext({}); //fake event
            setSideBarStepDescription(selectedItem.label)
            setFieldValue("filterById", selectedItem.value);
            setFieldValue("filterBy", selectedItem.filterValue);
        }
    }

    return (<div className="pt-3 pr-3 pl-3 h-full">
        <TableContextProvider
            useTable
            dataMethod={() => getEventBasedFilteredByData(translate)}
            tableDescriptor={ModesColumns}
            searchDescriptor={ModeSearch}
            disableSearch={true}
            maxPageSize={DEF_PG_SIZE_WIZARD}
            canExportReport={false}>
            <TableTab
                title={translate.byKey(TranslationKeys.filterBy)}
                selectRows={false}
                onRowClicked={itemSelected}
                tableId={'filterByTable'}
                style={{ maxHeight: "calc(100% - 70px)" }}
                cyName="filterStep"
            />
        </TableContextProvider>

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="py-1 px-5 secondary secondary-inverse"
                    type="button" onClick={onBack} >{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary ${taskSelected ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                    type="button"
                    onClick={e => onLocalNext(e)}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>

    </div>)
}

export default FilterStep;
